import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { CaseType } from "./case-type";
import { User } from "../../users/_types/user";
import { Contract } from "../../companies/_types/contract";

export class CaseTypeProcessorContract extends Resource {
    public override type = 'caseTypeProcessorContracts';

      @prop()    
        @required()
        public caseTypeId!: string;
        public caseType!: CaseType;
    
      @prop()
      public contractProcessorId!: string;

        @prop()    
        public processorId!: string;
        public processor!: User;   
        
        
        @prop()    
        public contractId!: string;
        public contract!: Contract;  
    
}